var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 131,
    viewBox: "0 0 202 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.051,
    cy: 35.6014,
    r: 12.6501,
    transform: "rotate(100.927 140.051 35.6014)",
    fill: "#ECCA49"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.635,
    cy: 80.8211,
    r: 12.6501,
    transform: "rotate(100.927 179.635 80.8211)",
    fill: "#E1B042"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3321,
    cy: 112.883,
    r: 12.6501,
    transform: "rotate(100.927 84.3321 112.883)",
    fill: "#F8CC76"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5484,
    cy: 95.9019,
    r: 12.6501,
    transform: "rotate(100.927 57.5484 95.9019)",
    fill: "#E3A04A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.6837,
    cy: 65.6493,
    r: 12.6501,
    transform: "rotate(100.927 67.6837 65.6493)",
    fill: "#ED6762"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.7281,
    cy: 30.5289,
    r: 12.6501,
    transform: "rotate(100.927 63.7281 30.5289)",
    fill: "#ED6762"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8931,
    cy: 67.1356,
    r: 12.6501,
    transform: "rotate(100.927 30.8931 67.1356)",
    fill: "#D44841"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.0069,
    cy: 32.4146,
    r: 12.6501,
    transform: "rotate(100.927 29.0069 32.4146)",
    fill: "#D44841"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.607,
    cy: 67.6165,
    r: 12.6501,
    transform: "rotate(100.927 144.607 67.6165)",
    fill: "#3882C7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.943,
    cy: 52.1419,
    r: 12.6501,
    transform: "rotate(100.927 108.943 52.1419)",
    fill: "#164B8A"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8892,
    cy: 106.304,
    r: 12.6501,
    transform: "rotate(100.927 16.8892 106.304)",
    fill: "#F3A374"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.338,
    cy: 84.0653,
    r: 12.6501,
    transform: "rotate(100.927 96.338 84.0653)",
    fill: "#D67742"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.392,
    cy: 105.586,
    r: 12.6501,
    transform: "rotate(100.927 124.392 105.586)",
    fill: "#EF8481"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.83,
    cy: 113.779,
    r: 12.6501,
    transform: "rotate(100.927 166.83 113.779)",
    fill: "#EF8481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b2b39cd5cc3a5c383cec4fa8903c0a87.svg";
export { ForwardRef as ReactComponent };